import callAPI from '../ApiConfig'
import store from '../../app/store'

const profile = async (props) => {
    const storeState = store.getState();
    
    return await callAPI({
        route:"wialon_customers/get_profile",
        method:"get",
        signal:props?.signal,
        params:props?.params,
        Headers:{
            'Content-Type':'application/json',
            Accept:'application/json'
        }
    })
    
}
const updateProfile = async (props) => {
    const storeState = store.getState();
    
    return await callAPI({
        route:"wialon_customers/update_profile",
        method:"put",
        signal:props?.signal,
        params:props?.params,
        data:props?.data,
        Headers:{
            'Content-Type':'multipart/form-data',
            Accept:'application/json'
        }
    })
    
}
const getConfigurationData = async (props) => {
    const storeState = store.getState();
    
    return await callAPI({
        route:"wialon_customers/configuration",
        method:"get",
        signal:props?.signal,
        params:props?.params,
        data:props?.data,
        Headers:{
            'Content-Type':'multipart/form-data',
            Accept:'application/json'
        }
    })
    
}






const profileAPI={
    Profile:profile,
    UpdateProfile:updateProfile,
    getConfigurationData:getConfigurationData,

}
export default profileAPI